<div class="modal-content">
  <div class="modal-header">
    <label class="modal-title text-text-bold-900" id="myModalLabel33"><b>Mobil etiket düzenle</b></label>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
 
    <div class="modal-body">

      <form [formGroup]="definitionForm">
        <div class="modal-body">
    
            <div class="form-group">
                <label>Etken Maddeler <button class="btn btn-success" (click)="addIngredients('')">+Ekle</button></label>
                        <div class="row">
                          <div class="col-md-4">
                            <label for="">Adı</label>
                          </div>
                            <div class="col-md-4">
                            <label for="">Miktarı</label>
                          </div>
                        </div>
                          <div formArrayName="activeIngredients"
                            *ngFor="let dep of getIngredients().controls;let i=index">
                            <div class="row mt-1" [formGroupName]="i">
                              <div class="col-md-4">
                               
                                <input type="text" class="form-control" formControlName="name" name="name"
                                  id="{{i}}name">
                              </div>
                              <div class="col-md-4">
                                <input type="text" class="form-control" formControlName="amount" name="amount"
                                  id="{{i}}amount">
                              </div>

                              <div class="col-md-1">
                                <i class="la la-trash danger cursor mt-1" (click)="removeIngredients(i)">

                                </i>
                              </div>
                            </div>
                          </div>
                        </div>
       
    
          <div class="form-group">
            <label>Endikasyon</label>
            <textarea class="form-control" formControlName="indications" rows="5" ></textarea>
          </div>

          

         
          <div formGroupName="dosageInstructions">
              <div class="form-group">
            <label>Doz Talimatı</label>
            <textarea class="form-control" formControlName="adults" rows="5"></textarea>
          </div>

         <div class="form-group">
            <label>Günlük maksimum doz</label>
            <input class="form-control" formControlName="maximumDailyDose"/>
          </div>
          </div>
    
    
          <div class="form-group">
                <label>Uyarılar <button class="btn btn-success" (click)="addWarning('')">+Ekle</button></label>

                          <div formArrayName="warnings"
                            *ngFor="let dep of getWarning().controls;let i=index">
                            <div class="row mt-1" [formGroupName]="i">
                              <div class="col-md-11">
                                <input type="text" class="form-control" formControlName="property" name="property"
                                  id="{{i}}property">
                              </div>
                             

                              <div class="col-md-1">
                                <i class="la la-trash danger cursor mt-1" (click)="removeWarning(i)">

                                </i>
                              </div>
                            </div>
                          </div>
                        </div>

    
          <div class="form-group">
            <label>Notlar</label>
            <textarea class="form-control" formControlName="administrationMethodNote" rows="5"></textarea>
          </div>
          
          
        </div>
    
        <div class="modal-footer">
          <button type="reset" class="btn grey btn-outline-secondary"
            (click)="close()">Kapat</button>
          <button type="button" class="btn btn-primary" (click)="save()" [disabled]="submitted">
            <i class="fa fa-refresh fa-spin" *ngIf="submitted"></i>
            Kaydet</button>
              <button type="button" class="btn btn-primary" (click)="saveall()" [disabled]="submitted">
            <i class="fa fa-refresh fa-spin" *ngIf="submitted"></i>
            Tüm eşdeğerleri güncelle</button>
        </div>
      </form>

</div>